import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import {getMessagemErro} from "../../utils/erro";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import { maskedCnpj } from "../../utils/maskUtil";
import api from "../../services/api";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import './Organization.css';
import { maskedCnpjInput } from '../../utils/maskUtil';

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const initialState = {
	resultadoPesquisa: [],
	nome: "",
	cnpj: "",
	sigla: "",
	esferaAdministrativa: "",
	uf: "",
	ufs : [],
	orgao: "",
	orgaos: [],
	naturezasJuridicas: [],
	naturezaJuridica: "",
	ativos: true,
	pesquisaExecutada: false,
	exibeModalAtivar: false,
	exibeModalInativar: false,
	botoesHabilitados : true,
};

export const OrganizationList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);

			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.fechaModais = this.fechaModais.bind(this);
			this.handleOkModais = this.handleOkModais.bind(this);		
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Órgãos</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}

			api.get('/api/orgao/perfil-usuario')
			.then(response => { this.setState({orgaos: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar os órgãos " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
			
			api.get('/api/unidade-federacao')
			.then(response => { this.setState({ufs: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar as unidades da federação " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			api.get('/api/natureza-juridica')
			.then(response => { this.setState({naturezasJuridicas: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar as naturezas jurídicas " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada, nome, cnpj, sigla, ativos, esferaAdministrativa, uf } = this.state;
			const { content } = resultadoPesquisa;
			const user = this.props.user;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalAtivar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente habilitar o órgão?"/>

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalInativar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente desabilitar o órgão?  As chaves geradas para as aplicações desse órgão acessarem as API's serão desabilitadas."/>

					<div className="br-form">
						<div className="row">
							<div className="col-md-4">
								<div className="field">
									<div className="input">
										<label htmlFor='orgao'>Órgão:</label>
											<SelectSearch
												id="orgao"
												name="orgao"
												options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={this.state.orgao}
											/>
									</div>
								</div>
							</div>
							
							<div className="col-md-4">
								<div className="field">
									<div className="input">
										<label htmlFor="nome">Nome:</label>
										<input type="text" name="nome" 
											value={nome}  
											onChange={this.handleInputChange} 
											maxLength="100"/>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="field">
									<div className="input">
										<label htmlFor="sigla">Sigla:</label>
										<input type="text" name="sigla" 
											value={sigla}
											onChange={this.handleInputChange} 
											maxLength="50"/>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="field">
									<div className="input">
										<label htmlFor="cnpj">CNPJ:</label>
										<input type="text" name="cnpj" 
											value={maskedCnpjInput(cnpj)}  
											onChange={(e) => {
												e.target.value = e.target.value.replace(/[.\-/]/g, "");
												this.handleInputChange(e);
											}}
											maxLength="18"/>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3">
								<div className="field">
									<div className="input">
										<label htmlFor='naturezaJuridica'>Natureza Jurídica:</label>
											<SelectSearch
												id="naturezaJuridica"
												name="naturezaJuridica"
												options={this.state.naturezasJuridicas.map(natureza => ({ value: natureza.id, label: natureza.nome }))}
												includeAllOption={true}
												onChange={this.handleInputChange}
												value={this.state.naturezaJuridica}
											/>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Esfera Administrativa:</label>
										<SelectSearch
											id="esferaAdministrativa"
											name="esferaAdministrativa"
											options={[{ value: "F", label: 'Federal' }, { value: "E", label: 'Estadual' }, { value: "M", label: 'Municipal' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={esferaAdministrativa}
										/>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Unidade da Federação:</label>
										<SelectSearch
											id="uf"
											name="uf"
											options={this.state.ufs.map(uf => ({ value: uf.id, label: uf.nome }))}
											includeAllOption={true}
											allOptionName="Todas"
											onChange={this.handleInputChange}
											value={uf}
										/>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Situação:</label>
										<SelectSearch
											id="ativos"
											name="ativos"
											options={[{ value: true, label: 'Ativos' }, { value: false, label: 'Inativos' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={ativos}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/organization/new"> 
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">CNPJ</th>
											<th scope="col">Nome</th>
											<th scope="col">Sigla</th>
											<th scope="col">Esfera Administrativa</th>
											<th scope="col">Natureza Jurídica</th>
											<th scope="col">Unidade da Federação</th>
											<th scope="col">Adesões</th>
											<th scope="col">Situação</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((orgao, index) =>
													<tr key={index} >
														<td>{maskedCnpj(orgao.cnpj)}</td>
														<td>{orgao.nome}</td>
														<td>{orgao.sigla}</td>
														<td>{orgao.nomeEsferaAdministrativa}</td>
														<td>{orgao.naturezaJuridica} - {orgao.nomeNaturezaJuridica}</td>
														<td>{orgao.nomeUf}</td>
														<td>
														{(orgao.adesoes && orgao.adesoes.length > 0) && <ul>{orgao.adesoes.map(adesao => <li>{adesao.nomeFornecedora}</li>)}</ul>}
														</td>
														<td>
															{orgao.ativo === true ? 'Ativo' : 'Inativo'}
														</td>
														<td className="text-center">
															<div className="actions">
																{ (user.isAdministrador === true || (user.isGestorAPI === true && orgao.isCliente === true)) && 
																	<Link to={`/organization/edit/${orgao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados} title="Editar o órgão">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</Link>
																}

																{ orgao.ativo === true &&
																	<Link to={`/organization/access/${orgao.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados}  title="Editar as adesões do órgão">
																			<span className="sr-only">Adesões</span>
																			<i className="fas fa-handshake"></i>
																		</button>
																	</Link>
																}

																{ orgao.ativo === false &&
																	<button type="button" disabled="true"  title="Editar as adesões do órgão">
																		<span className="sr-only">Adesões</span>
																		<i className="fas fa-handshake"></i>
																	</button>
																}

																{ user.isAdministrador === true && orgao.ativo === true &&
																	<button type="button" onClick={() => this.confirmaOperacao(orgao)} disabled={!this.state.botoesHabilitados} title="Desabilitar o órgão">
																		<span className="sr-only">Desativar</span>
																		<i className="fas fa-power-off" id="on"></i>
																	</button>
																}
																
																{ user.isAdministrador === true && orgao.ativo === false &&
																	<button type="button" onClick={() => this.confirmaOperacao(orgao)} disabled={!this.state.botoesHabilitados} title="Habilitar o órgão">
																		<span className="sr-only">Ativar</span>
																		<i className="fas fa-power-off" id="off"></i>
																	</button>
																}
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum órgão encontrado com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {orgao, cnpj, nome, sigla, ativos, esferaAdministrativa, uf, naturezaJuridica} = this.state;
			const criterioPesquisa = {orgao, cnpj, nome, sigla, ativos, esferaAdministrativa, uf, naturezaJuridica, pagina};
			const url = '/api/orgao/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os órgãos. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState({
				...initialState,
				ufs: this.state.ufs,
				orgaos: this.state.orgaos,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}

		alterarSituacao (orgao){ 
			const body = { ativo: !orgao.ativo }
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			api.put(`/api/orgao/situacao/${orgao.id}`, body)
				.then(response => { 
					this.setState({
						pesquisaExecutada : true,
					}) 
					this.pesquisar();
					let mensagem = orgao.ativo === true ? 'Órgão desabilitado com sucesso!' : 'Órgão habilitado com sucesso!';
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = 'Não foi possível alterar a situação do órgão.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		handleOkModais () {
			this.alterarSituacao(this.state.orgaoAlvo);
			this.fechaModais();
		}

		confirmaOperacao(orgao) {
			this.setState(
				{
					exibeModalAtivar: orgao.ativo === false,
					exibeModalInativar: orgao.ativo === true,
					orgaoAlvo: orgao,
				}
			);
		}

		fechaModais () {
			this.setState(
				{
					exibeModalAtivar:false,
					exibeModalInativar:false
				}
			);
		}
	}

) // redux
); // router